<!-- Capa de bloqueo total de interacción -->
<div *ngIf="active" class="tour-blocker" (click)="$event.stopPropagation()"></div>

<!-- Fondo oscuro mediante sombra de la caja de resaltado -->
<div *ngIf="active" class="tour-highlight-box" [ngStyle]="highlightStyle" (click)="stop()"></div>

<!-- Popover -->
<div *ngIf="active && currentStep" [ngStyle]="popoverStyle"
    class="tour-popover shadow-2xl animate-in fade-in zoom-in duration-200">

    <div
        class="tour-popover-content flex flex-col w-[340px] bg-white rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.3)] overflow-hidden">

        <!-- Barra de Progreso Superior -->
        <div class="h-1.5 w-full bg-gray-100 flex">
            <div class="h-full transition-all duration-500 ease-out"
                [style.width.%]="((currentStepIndex + 1) / steps.length) * 100"
                [style.background-color]="color_primario"></div>
        </div>

        <div class="p-8">
            <!-- Header: Indicador de Paso y Cerrar -->
            <div class="flex items-center justify-between mb-6">
                <div class="flex items-center">
                    <div class="w-8 h-8 rounded-lg flex items-center justify-center mr-3 font-black text-white text-xs"
                        [style.background-color]="color_primario">
                        {{ currentStepIndex + 1 }}
                    </div>
                    <span class="text-[10px] font-black uppercase tracking-widest text-gray-400">
                        Paso {{ currentStepIndex + 1 }} de {{ steps.length }}
                    </span>
                </div>
                <button mat-icon-button (click)="stop()"
                    class="w-8 h-8 min-h-8 bg-gray-50 hover:bg-red-50 hover:text-red-500 transition-colors rounded-lg">
                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
            </div>

            <!-- Cuerpo del Tour -->
            <div class="flex flex-col mb-8">
                <h3 class="text-xl font-black text-gray-800 leading-tight mb-3">
                    {{ currentStep.title }}
                </h3>
                <p class="text-sm text-gray-500 leading-relaxed">
                    {{ currentStep.content }}
                </p>
            </div>

            <!-- Footer: Navegación -->
            <div class="flex items-center justify-between gap-4">
                <button mat-button class="font-bold text-gray-400 px-0 min-w-0" (click)="previous()"
                    *ngIf="currentStepIndex > 0">
                    Anterior
                </button>
                <div class="flex-1" *ngIf="currentStepIndex === 0"></div>

                <button mat-flat-button [style.background-color]="color_primario"
                    *ngIf="!currentStep.hideNext"
                    class="flex-1 py-6 rounded-2xl text-white font-bold shadow-lg hover:scale-105 transition-all duration-200 gap-2"
                    (click)="next()">
                    <span class="mr-1">
                        {{ currentStep.nextLabel || (currentStepIndex + 1 === steps.length ? 'Finalizar' : 'Siguiente')
                        }}
                    </span>
                    <mat-icon *ngIf="currentStepIndex + 1 < steps.length" class="icon-size-4"
                        [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>